<template>
    <div class="login">
        <van-tabs>
            <van-tab title="账号密码登录">
                <div class="login-phone-box">
                    <span class="phone-icon"></span>
                    <input
                        class="login-input"
                        v-model="passWordForm.phone"
                        placeholder="请输入11位手机号"
                        @blur="pswLoginPhoneCheck"
                    />
                </div>
				<span class="error-message">{{pswphoneError}}</span>
                <div class="login-password-box">
                    <span class="password-icon"></span>
                    <input
                        class="login-input"
                        v-model="passWordForm.password"
                        type="password"
                        placeholder="请输入密码"
                        @blur="pswLoginPswCheck"
                    />
                </div>
				<span class="error-message">{{pswError}}</span>
                <div class="save-info-box">
                    <van-checkbox v-model="checked">保存用户名和密码</van-checkbox>
                    <router-link :to="{name:'pswreset',params:{pageType:'pswreset'}}" class="psw-reset-href">忘记密码</router-link>
                </div>
                <button :disabled="btnSubmitingDisabled" :class="{'login-submit':true,'btn-submiting':btnSubmiting}" ref="pswLoginBtn" @click="pswLoginSubmit">登录</button>
            </van-tab>
            <van-tab title="手机号登录">
                <div class="icode-phone-box">
                    <span class="phone-icon"></span>
                    <input
                        class="login-input"
                        v-model="iCodeForm.phone"
                        placeholder="请输入11位手机号"
                        @blur="iCodeLoginPhoneCheck"
                    />
                </div>
				<span class="error-message">{{icodephoneError}}</span>
                <div class="icode-box">
                    <span class="icode-icon"></span>
                    <input
                        class="login-input"
                        v-model="iCodeForm.icode"
                        placeholder="请输入6位验证码"
                        @blur="iCodeLoginCheck"
                    />
                    <van-button :disabled="identCodeDisabled" @click="getIdentCode"><span v-if="reIndentCodeText">重新</span>获取验证码<span v-if="reIndentCodeNum">{{countdown}}</span></van-button>
                </div>
				<span class="error-message">{{icodeError}}</span>
                <div class="save-info-box">
                    <router-link :to="{name:'pswreset'}" class="psw-reset-href">忘记密码</router-link>
                </div>
                <div :disabled="iBtnSubmitingDisabled" :class="{'login-submit':true,'btn-submiting':iBtnSubmiting}" ref="iCodeLoginBtn" @click="iCodeLoginSubmit">登录</div>
            </van-tab>
        </van-tabs>
    </div>
</template>
<script>
import {AxiosOld} from '@/assets/api/axios'
import {GetCookie,SetCookie,DelCookie} from '@/assets/api/cookie'
import {phoneNumCheck,identCodeCheck} from '@/assets/api/validate'
import {compileStr,uncompileStr} from '@/assets/api/encryption'
import {Dialog} from 'vant'
import HeaderNav from '@/components/HeaderNav.vue'
import notifyIcon from '@/assets/img/msgicon.png'
export default {
	name: 'Login',
	beforeRouteEnter(to,from,next){
		next(
			vm=>{
				vm.setLoginSucBackTo(from.fullPath)
			}
		)
	},
	data(){
		return{
			passWordForm:{                 //密码登录表单数据
				phone:'',
				password:''
			},
			iCodeForm:{                    //验证码登录表单数据
				phone:'',
				icode:''
			},
			checked:false,                 //保存用户名密码选中状态
			btnSubmiting:false,            //控制登录按钮放重复提交样式
			btnSubmitingDisabled:false,    //控制登录按钮放重复提交
			pswphoneError:'',              //密码登录表单手机号错误提示
			pswError:'',                   //密码登录表单密码错误提示

			icodephoneError:'',            //验证码登录表单手机号错误提示
			icodeError:'',                 //验证登录表单验证码错误提示
			iBtnSubmitingDisabled:false,   //验证码登录提交按钮禁用状态控制
			iBtnSubmiting:false,           //验证码登录提交按钮禁用样式  
			identCodeDisabled:true,       //控制获取验证码按钮点击状态
			reIndentCodeText:false,        //验证码登录重新获取验证码文字显示
			reIndentCodeNum:false,         //验证码登录重新获取验证码倒计时显示
			countdown:30,                  //重新获取验证码倒计时
			timer:'',                      //重新获取验证码倒计时
			loginFromPage:'',              //储存从哪个页面来到登录页 登录之后跳转回
			comeFrom:'',                   //页面从哪里来
			comeFromArr:'',                //页面从哪里来逻辑处理
		}
	},
	created(){
        this.comeFrom=document.referrer
		this.comeFromArr=this.comeFrom.split('/')
		if(GetCookie('tel')){
			this.checked=true
			this.passWordForm.phone=GetCookie('tel')
			this.passWordForm.password=uncompileStr(GetCookie('password'))
		}
	},
	watch:{
		//监听验证密码登录表单手机号
		"passWordForm.phone":function(){
            if(this.passWordForm.phone.length===11){
                AxiosOld.get("/phone/info",{params:{"phone":this.passWordForm.phone}})
                .then(
                    response=>{
                        if(response.data.data===0){
                        this.pswphoneError="该手机号未注册"
                        }
                        else if(response.data.data===1){
                            this.pswphoneError=""
                        }
                    }
                )
            }
	    },
        //监听验证验证码表单登录手机号
        "iCodeForm.phone":function(){
            if(this.iCodeForm.phone.length!==11){
                this.identCodeDisabled=true
            }
            if(this.iCodeForm.phone.length===11){
                AxiosOld.get("/phone/info",{params:{"phone":this.iCodeForm.phone}})
                .then(
                response=>{
                    if(response.data.data===0){
                        this.identCodeDisabled=true
                        this.icodephoneError="该手机号未注册"
                    }
                    else if(response.data.data===1){
                        this.identCodeDisabled=false
                        this.icodephoneError=""
                    }
                }
                )
            }
        },
    //重新获取验证码倒计时显示
        countdown:function(){
            if(this.countdown<=0){
                clearInterval(this.timer);
                this.reIndentCodeNum=false;
                this.identCodeDisabled=false;
                this.countdown=30;
            }
        },
    //修复iPhone自动填入验证码填两遍的BUG
        "iCodeForm.icode":function(val){
            if(val.length>6){
                this.iCodeForm.icode=val.substring(0,6)
            }
        }
    },
    methods:{
	//设置登录成功后后跳转路由
	setLoginSucBackTo(routerName){
		if(routerName=="/"||routerName=="/pswreset"||routerName=="/register"||routerName==""){
			this.loginFromPage="/"
        }
		else{
			this.loginFromPage=routerName
		}
	},
    //密码登录表单手机号验证
    pswLoginPhoneCheck(){
        if(!phoneNumCheck(this.passWordForm.phone)){
            this.pswphoneError="请输入正确手机号"
            return false
        }else{
            return true
        }
    },
    //密码登录表单密码验证
    pswLoginPswCheck(){
        if(this.passWordForm.password==""){
            this.pswError="请输入密码"
            return false
        }else{
            this.pswError=""
            return true
        }
    },
    //密码登表单提交
    pswLoginSubmit(){
        this.pswLoginPhoneCheck()
        this.pswLoginPswCheck()
        let validateRes=!this.pswphoneError&&!this.pswError
        if(validateRes){
            if(this.checked){
                SetCookie('tel',this.passWordForm.phone)
                SetCookie('password',compileStr(this.passWordForm.password))
            }else if(!this.checked){
                DelCookie('tel')
                DelCookie('password')
            }
            this.btnSubmiting=true
            this.btnSubmitingDisabled=true
            this.$refs.pswLoginBtn.innerHTML="登录中..."    
            AxiosOld.post('login',{"phone":this.passWordForm.phone,"password":this.passWordForm.password})
            .then(
                response=>{
                    this.btnSubmiting=false
                    this.btnSubmitingDisabled=false
                    this.$refs.pswLoginBtn.innerHTML="登录"
                    if(response.data.data.errCode==1002&&response.data.code==200){
                        this.pswError="密码错误"
                        return
                    }else if(response.data.code==201&&response.data.status=="success"){
                        SetCookie('token',response.data.data.token)
                        SetCookie('phone',response.data.data.phone)
						SetCookie('real_auth',response.data.data.real_name_auth)
						SetCookie('pn',response.data.data.name)
						SetCookie('v',response.data.data.white_info.is_vip)
						this.$swal({
							text:'登录成功',
							showConfirmButton:false,
							width:'6rem',
							padding:'0.5rem',
							timer:800,
							imageWidth:50,
							imageHeight:50,
							imageUrl:notifyIcon,
							timerProgressBar: true
						})
						if(this.comeFromArr.indexOf('security')>-1||this.comeFromArr.indexOf('login')>-1||this.comeFromArr.indexOf('pswreset')>-1){
							setTimeout(()=>{
								location.href="/"
							},800)
						}else if(this.comeFrom==""&&this.loginFromPage=="/"){
							setTimeout(()=>{
								location.href="/"
							},800)
						}else if(this.comeFrom==""&&this.loginFromPage!=="/"){
							setTimeout(()=>{
								this.$router.push(this.loginFromPage)
							},800)
						}
						else{
							setTimeout(()=>{
								location.href=this.comeFrom
							},800)
						}
                    }
                }
            )
            .catch(
                error=>{
                    this.btnSubmiting=false
                    this.btnSubmitingDisabled=false
                    this.$refs.pswLoginBtn.innerHTML="登录"
                    this.$swal({
						text:'网络错误 请稍后重试',
						showConfirmButton:false,
						width:'6rem',
						padding:'0.5rem',
						timer:1000,
						imageWidth:50,
						imageHeight:50,
						imageUrl:notifyIcon,
						timerProgressBar: true
					})
                }
            )
        }
    },
    //验证码登录获取验证码
    getIdentCode(){
        AxiosOld.post('sendsms',{"phone":this.iCodeForm.phone,"login":1})
        .then(
            response=>{
                if(response.data.code==200&&response.data.status=="success"){
					this.identCodeDisabled=true;
					this.reIndentCodeText=true;
					this.reIndentCodeNum=true;
					this.timer=setInterval(()=>{
						this.countdown-=1;
					},1000)
                }
            }
        )
        .catch(
            error=>{
                this.$swal({
					text:'网络错误 请稍后重试',
					showConfirmButton:false,
					width:'6rem',
					padding:'0.5rem',
					timer:1000,
					imageWidth:50,
					imageHeight:50,
					imageUrl:notifyIcon,
					timerProgressBar: true
				})
            }
        )
    },
    //验证码登录表单手机验证
    iCodeLoginPhoneCheck(){
        if(!phoneNumCheck(this.iCodeForm.phone)){
            this.icodephoneError="请输入正确手机号"
            this.identCodeDisabled=true
            return false
        }else{
            return true
        }
    },
    //验证码登录表单验证码验证
    iCodeLoginCheck(){
        if(identCodeCheck(this.iCodeForm.icode)){
            this.icodeError=""
            return true
        }else{
            this.icodeError="请输入正确验证码"
            return false
        }
    },
    //验证码登录表单提交
    iCodeLoginSubmit(){
        this.iCodeLoginPhoneCheck()
        this.iCodeLoginCheck()
        let validateRes=!this.icodephoneError&&!this.icodeError
        if(validateRes){
            this.iBtnSubmitingDisabled=true
            this.iBtnSubmiting=true
            this.$refs.iCodeLoginBtn.innerHTML="登录中..."
            AxiosOld.post('login',{"phone":this.iCodeForm.phone,"code":this.iCodeForm.icode})
            .then(
                response=>{
                    this.iBtnSubmitingDisabled=false
                    this.iBtnSubmiting=false
                    this.$refs.iCodeLoginBtn.innerHTML="登录"
                    if(response.data.data.errcode==1000&&response.data.code==200){
                        this.icodeError="验证码错误"
                    }else if(response.data.data.errcode==1001&&response.data.code==200){
                        this.icodeError="验证码错误"
                    }else if(response.data.code==201&&response.data.status=="success"){
                        SetCookie('token',response.data.data.token)
                        SetCookie('phone',response.data.data.phone)
						SetCookie('real_auth',response.data.data.real_name_auth)
						SetCookie('pn',response.data.data.name)
						SetCookie('v',response.data.data.white_info.is_vip)
						this.$swal({
							text:'登录成功',
							showConfirmButton:false,
							width:'6rem',
							padding:'0.5rem',
							timer:800,
							imageWidth:50,
							imageHeight:50,
							imageUrl:notifyIcon,
							timerProgressBar: true
						});
						if(this.comeFromArr.indexOf('security')>-1||this.comeFromArr.indexOf('login')>-1||this.comeFromArr.indexOf('pswreset')>-1){
							setTimeout(()=>{
								location.href="/"
							},800)
						}else if(this.comeFrom==""&&this.loginFromPage=="/"){
							setTimeout(()=>{
								location.href="/"
							},800)
						}else if(this.comeFrom==""&&this.loginFromPage!=="/"){
							setTimeout(()=>{
								this.$router.push(this.loginFromPage)
							},800)
						}
						else{
							setTimeout(()=>{
								location.href=this.comeFrom
							},800)
						}
                    }
                }
            ).catch(
                error=>{
                    this.$swal({
						text:'网络错误 请稍后重试',
						showConfirmButton:false,
						width:'6rem',
						padding:'0.5rem',
						timer:1000,
						imageWidth:50,
						imageHeight:50,
						imageUrl:notifyIcon,
						timerProgressBar: true
					})
                }
            )
        }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.login{
    padding:80px;
    padding-top:180px;
    width:590px;
}
//TAb下换线和字体样式修改开始
.van-tabs--line .van-tabs__wrap{
    height:60px !important;
    margin-bottom:60px !important;
}
.van-tab__text{
    font-size:28px !important;
    color:#302D2D;
}
.van-tab--active{
    .van-tab__text{
        font-size:30px !important;
        color:#222;
        font-weight:bold;
    }
}
.van-tabs__line{
    width:30px !important;
    background-color:#bf0000 !important;
    height:6px;
}
.error-message{
    color:#bf0000;
    padding-left:20px;
    padding-top:6px;
    font-size:20px;
    height:20px;
    display:block;
    margin-bottom:20px;
}
//TAb下换线和字体样式修改结束

//输入框样式修改开始
.van-tabs__wrap{
    margin-bottom:40px;
}
.van-cell{
    margin-bottom:30px;
}
.login-phone-box,.login-password-box,.psw-box,.repsw-box{
    position:relative;
    .phone-icon,.password-icon{
        display:inline-block;
        position:absolute;
        top:50%;
        left:24px;
        transform:translateY(-15px);
    }
    .phone-icon{
        width:22px;
        height:26px;
        background:url('../assets/img/phoneicon.png') no-repeat;
        background-size:100% 100%;
    }
    .password-icon{
        width:26px;
        height:26px;
        background:url('../assets/img/pswicon.png') no-repeat;
        background-size:100% 100%;
    }
}
.login-input{
    border:none;
    width:506px;
	height:30px;
    line-height:24px;
    background:rgba(247,247,247,1);
    border-radius:35px;
    padding:20px 0 20px 80px;
    font-size:24px;
    color:#222;
    margin-bottom:6px;
}
input::-webkit-input-placeholder{
    color: #ccc !important;
	line-height:30px;
}
input:-moz-placeholder{
    color: #ccc !important;
	line-height:30px;
}
input::-moz-placeholder{
    color: #ccc !important;
	line-height:30px;
}
input:-ms-input-placeholder{
    color: #ccc !important;
	line-height:30px;
}
.save-info-box{
    height:40px;
	line-height:40px;
    margin-bottom:70px;
	padding-top:20px;
    .van-checkbox{
        margin-left:10px;
		height:40px;
		line-height:40px;
		overflow:visible;
		float:left;
    }
    .van-checkbox__label{
		display:inline-block;
		height:40px;
		line-height:40px;
        font-size:22px;
        color:#999;
    }
    .van-checkbox__icon--checked .van-icon{
        background-color:#bf0000 !important;
        border-color:#bf0000 !important;
    }
    .psw-reset-href{
        float:right;
        font-size:22px;
        color:#222;
        margin-right:12px;
    }
}
.login-submit{
    width:586px;
    height:70px;
    line-height:70px;
    text-align:center;
    color:#fff;
    font-size:24px;
    border:none;
    background:#bf0000;
    border-radius:35px;
}
.login-submit:active{
    background:#DD8080;  
}
//输入框样式修改结束

//手机号登录表单样式开始
.icode-phone-box{
    @extend .login-phone-box;
	margin-bottom:0 !important;
	.phone-icon{
		display:inline-block;
        position:absolute;
        top:50%;
        left:24px;
        transform:translateY(-13px);
		width:22px !important;
        height:26px !important;
        background:url('../assets/img/phoneicon.png') no-repeat;
        background-size:100% 100%;
	}
}
.icode-box{
    position:relative;
	margin-bottom:0 !important;
    .icode-icon{
        display:inline-block;
        background:red;
        position:absolute;
        top:50%;
        left:24px;
        transform:translateY(-18px);
        width:26px;
        height:29px;
        background:url('../assets/img/icodeicon.png') no-repeat;
        background-size:100% 100%;
    }
    .van-button{
        position:absolute;
        right:20px;
        top:16px;
        color:#bf0000;
        background:rgba(247,247,247,1);
        border:none;
        font-size:22px;
    }
}
//手机号登录表单样式结束
</style>